import * as Immutable from 'immutable';
import { PaginationItem, IPaginationStore} from './PaginationStore'

interface IUserImageStore extends PaginationItem {
	id: string
	name: string
	filename: string
	fileid: string
	width: number
	height: number
	chunked: boolean
}

const defaultUserImageStore = Immutable.Record<IUserImageStore>({
	id: undefined,
	name: undefined,
	filename: undefined,
	fileid: undefined,
	width: 0,
	height: 0,
	chunked: false,
});

export class UserImageStore extends defaultUserImageStore implements IUserImageStore {}

export interface IUserImageListStore extends IPaginationStore {
	items: Immutable.OrderedMap<string, UserImageStore>,
}

const defaultUserImageListStore = Immutable.Record<IPaginationStore>({
	items: Immutable.OrderedMap<string, UserImageStore>(),
	total: 0,
	valid: false,
	loading: false,
});

export default class UserImageListStore extends defaultUserImageListStore implements IUserImageListStore {}